export const API_BASE_URL_IMAGE =
  import.meta.env.VITE_ENV_API_BASEURL_image ||
  "http://localhost:5000/uploads/";

export const API_BASE_URL =
  import.meta.env.VITE_ENV_API_BASEURL || "http://localhost:5000";

export const ENDPOINTS = {
  AUTH: {
    login: "/v1/auth/login",
    logout: "/v1/auth/logout",
    signup: "",
    refresh: "",
    emailVariations: "/v1/auth/forgot-password",
    resetPassword: "/v1/auth/reset-password",
  },
  ADMIN: {
    request: "/v1/request/",
    getActiveTenants: "/v1/users/tenants",
    getAllTenants: "/v1/tenantProfile/allTenants",
    tenantsUsers: "/v1/users/tenants-users",
    tenantsUsedData: "/v1/users/tenants-license",
    tenantsUsageTracker: "/v1/usage/dashboard/tenentusage-count-graph",
    tenantsUsageTrackerById: (id: string) =>
      `/v1/usage/tenant/${id}/usage-count-graph`,
    webScraping: (id: string) => `/v1/tenantProfile/${id}/scraper`,
    updateActiveTenantsById: (id: string) => `/v1/users/tenants/${id}`,
    uploadTenantLogo: (id: string) => `/v1/users/tenants/${id}/logo`,
    usageLogsQueryKey: (tenantId: string) => `/v1/usage/usagelogs/${tenantId}`,
    tenantFeatures: (tenantId: string) =>
      `/v1/usage/tenant/${tenantId}/features`,
    approveRequest: (id: string) => `/v1/request/${id}/approve`,
    rejectRequest: (id: string) => `/v1/request/${id}/reject`,
  },
  CREDITS: {
    usage: "/v1/credits/usage",
    grant: "/v1/credits/grant",
    splitGrant: "/v1/credits/split-grant",
  },
  TENANT: {
    users: "/v1/tenant-dashboard/getTenantUser/",
    usersByID: (id: string) => `/v1/tenant-dashboard/getTenantUser/${id}`,
    pitchCount: "/v1/tenant-dashboard/getTenantPitch",
    tenantProfile: "/v1/tenantProfile/",
    getTenantDashboardData: "/v1/tenant-dashboard/getTenantDashboardData",
    getTenantDashboardOverview: "/v1/tenant-dashboard/getTenantDashboardOverview",
    tenantProfileById: (id: string) => `/v1/tenantProfile/${id}`,
    createTenantProfile: (id: string) => `/v1/tenantProfile/${id}`,
    // Rep coaching insights (POST + GET) – repId in path
    repCoaching: (repId: string) =>
      `/v1/tenant-dashboard/rep-coaching/${repId}`,
    // Team coaching overview (GET only)
    teamCoachingOverview: '/v1/tenant-dashboard/team-coaching-overview',
    generateTeamCoachingInsights: '/v1/tenant-dashboard/team-coaching-insights/generate',
    checkScenarioMatch: '/v1/tenant-dashboard/coaching/check-scenario-match',
  },
  ADD_USER: {
    register: "/v1/auth/register",
  },
  TEAM: {
    TEAM: "/v1/teams/",
    TEAM_UPDATE: (id: string) => `/v1/teams/${id}/users`,
    getAll: "/v1/teams/",
    TEAM_DELETE: (teamId: string, userId: string) =>
      `/v1/teams/${teamId}/users/${userId}`,
  },
  UPDATE_USER: {
    updateUser: (id: string) => `/v1/users/${id}`,
    create: `/v1/users`,
    deleted: "/v1/users/deleted",
    restore: (id: string) => `/v1/users/${id}/restore`,
  },
  SUBSCRIPTION: {
    getSubscription: "/v1/planMaster/",
  },
  SCRIPT: {
    scriptGeneration: "/v1/scriptGen/createScript",
    generatePersonalizedSections: "/v1/scriptGen/generate-personalized",
    repInsights: (userId: string) => `/v1/scriptGen/rep-insights/${userId}`,
    companyInsights: (companyId: string) => `/v1/scriptGen/company-insights/${companyId}`,
    scriptCardData: "/v1/scriptGen/scriptCardData",
    generatedScriptData: "/v1/scriptGen/scriptMeta",
    scriptDashboardOverview: (tenantId: string) => `/v1/scriptGen/dashboardOverview/${tenantId}`,
    reassignScript: (assignmentId: string) => `/v1/scriptGen/assignment/${assignmentId}/reassign`,
  },
  NOTIFICATION: {
    unReadCount: "/v1/notification/unread-count",
    getNotifications: "/v1/notification",
    markAsRead: "/v1/notification/mark-all-read",
    markNotificationAsRead: (id: string) => `/v1/notification/${id}/read`,
  },
  CONTACT: {
    sendMessage: "/v1/contact/",
  },
  SOCIAL_POSTS: {
    base: "/v1/social-posts",
    getAll: "/v1/social-posts/all",
    upload: "/v1/social-posts/media/upload",
    byId: (id: string) => `/v1/social-posts/${id}`,
  },
  Meeting: {
    base: '/v1/meeting',
  },
  CUSTOMER: {
    base: '/v1/customer',
  },
  COMPANY_CONTACT: {
    base: '/v1/companyContact',
  },
};
